import CityLandingPage from './CityLandingPage';
import { cityPages } from '@/mocks/cityPages';

const data = cityPages.find((c) => c.slug === 'electronics-recycling-glendale')!;
const GlendalePage = () => <CityLandingPage data={data} />;
export default GlendalePage;
